import {useEffect, useState} from "react";
import axios from "axios";

export default function (prefix, token) {
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        configure();

        return () => axios.interceptors.request.clear();
    }, []);

    const configure = async () => {
        axios.interceptors.request.use(
            config => {
                if (config.url.includes("service-assignment")
                    || config.url.includes("service-emergency")
                    || config.url.includes("service-b2c")
                    || config.url.includes("service-insurance")) {
                    config.headers['X-Auth-Token'] = `${prefix}-${token}`;
                }

                return config;
            },
            error => {
                return Promise.reject(error);
            }
        );

        setInitialized(true);
    }

    return initialized;
}